import ApiConstant from "./ApiContstant";
import DataService from "./DataService";

class LanguageService {

    async getLoginLanguageData(langCode: string) {
        return (DataService.getData(localStorage.getItem('tenantUrl') + ApiConstant.GetLoginLanguageInfo + langCode));
    }

    async getLanguageData(langCode: string) {
        return (DataService.getData(localStorage.getItem('tenantUrl') + ApiConstant.GetLanguageInfo + langCode));
    }
};

export default new LanguageService;